module.exports = __webpack_public_path__ + "static/img/ban.3bfb142c.png";